import API from 'services/TAPS_API';

export default function getCurrencyRates({ currency, date }) {
  return API.request({
    method: 'GET',
    url: `/dictionary/currency-rates`,
    params: {
      code: currency,
      date,
    },
    headers: {
      'Content-Type': 'application/json;charset=UTF-8',
    },
  });
}
